export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return <span className={`brand-lockup ${compact ? 'compact' : ''}`} aria-hidden="true">
    <svg className="brand-mark" viewBox="0 0 64 64" role="presentation">
      <defs>
        <linearGradient id="resod-mark" x1="8" y1="6" x2="55" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#176957"/>
          <stop offset="1" stopColor="#06372f"/>
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="19" fill="url(#resod-mark)"/>
      <path d="M19 45V19h13.2c8.2 0 13.2 4 13.2 10.7 0 4.7-2.8 8.1-7.3 9.6L46 45h-9.2l-6.5-5.2h-3.6V45H19Zm7.7-11.7h5c3.8 0 5.8-1.2 5.8-3.6 0-2.5-2-3.7-5.8-3.7h-5v7.3Z" fill="#fff"/>
      <circle cx="47.5" cy="16.5" r="5.5" fill="#D99563"/>
    </svg>
    <span className="brand-wordmark"><strong>ReSOD</strong><small>쉬운 제품안내</small></span>
  </span>
}
